<template>
    <div class="noticia">
        <Header></Header>

        <div class="my-5">
            <div class="container">
                <div class="row" v-if="noticia != null">
                    <div class="col-12 col-md-8">
                        <DivisorIcone :textSize="24" :title="title" :tag="noticia.nmSubCategoria"></DivisorIcone>

                        <div class="d-flex justify-content-between mt-2">
                            <span class="txt-h-6 txt-size-10 txt-grey-2">
                                {{formatDate(noticia.dtPublicacao)}}
                            </span>

                            <div class="funcoes-noticia d-flex align-items-center">
                                <div class="txt-h-6 txt-size-10 txt-grey-7 divisor-rigth px-3 text-decoration-underline d-flex align-items-center c-pointer"
                                     v-if="noticia.idNoticiaIngles != null"
                                     @click="trocaLinguagem">
                                    <i class="fa fa-language fa-2x mr-2"></i>

                                    Traduzir texto
                                </div>

                                <div class="divisor-rigth px-3">
                                    <span class="txt-h-6 txt-size-16 txt-grey-7">
                                        Tamanho da fonte:
                                    </span>
                                    <button class="btn p-0 mx-2 txt-h-6 txt-size-16 txt-grey-7" @click="trocaFonte(1)"> <i class="fas fa-minus"></i> </button>
                                    <button class="btn p-0 txt-h-6 txt-size-16 txt-grey-7" @click="trocaFonte(2)"> <i class="fas fa-plus"></i> </button>
                                </div>
                                <div class="ps-3 txt-size-25 ">
                                    <a class="txt-grey-7" :href="getLinkShare(1)" target="_blank"><i class="fab fa-facebook-square c-pointer me-2"></i></a>
                                    <a class="txt-grey-7" :href="getLinkShare(2)" target="_blank"><i class="fab fa-twitter-square c-pointer me-2"></i></a>
                                    <a class="txt-grey-7" :href="getLinkShare(3)" target="_blank"><i class="fab fa-linkedin c-pointer me-2"></i></a>
                                    <a class="txt-grey-7" :href="getLinkShare(4)" target="_blank"><i class="fab fa-whatsapp-square c-pointer"></i></a>
                                    <button class="btn px-0 mx-2 txt-grey-7 " href="#"  @click="share" target="_blank"><i class="fas fa-share-alt"></i></button>
                                </div>
                            </div>
                        </div>


                        <p class="txt-h-1 txt-blue-2 mt-3 mb-0">
                            {{dadosExibicao.dsTitulo}}
                        </p>

                        <p class="txt-p txt-size-20 txt-w-5 txt-grey-2 mt-3">
                            {{dadosExibicao.dsSubTitulo}}
                        </p>

                        <AdicionarBiblioteca :titulo="dadosExibicao.dsTitulo" :id="noticia.idNoticia.toString()" :tipo="'Notícia'" v-if="user != null"></AdicionarBiblioteca>

                        <figure class="mt-3">
                            <picture>
                                <!--<source :srcset="noticia.urlImagemInterna" media="(min-width: 600px)">-->
                                <img class="w-100 imagem-noticia" :src="noticia.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" :alt="noticia.dsLegendaImagemInterna" />
                            </picture>
                            <figcaption class="mt-2" v-if="noticia.dsLegendaImagemInterna">{{noticia.dsLegendaImagemInterna}}</figcaption>

                        </figure>


                        <!--    CONTEUDO DA NOTICIA    -->
                        <div class="conteudo-noticia mt-3 txt-p" v-html="dadosExibicao.htmNoticia" :style="'font-size:'+tamanhoFonte+'rem'" oncopy="return false" oncut="return false" onpaste="return false"></div>
                        <!-- SE USUARIO LOGADO NÃO LOGADO -->
                        <!-- SE NOTICIA NÃO PUBLICA -->
                        <ConteudoExclusivo v-if="user == null && noticia.flPublico != 'Sim'" :liberaConteudo="liberaConteudo"  />

                        <!-- MIDIA (AUDIO/VIDEO) -->
                        <template v-if="user || noticia.flPublico == 'Sim' ">
                            <div class="row" v-if="noticia.urlMidia">
                                <template v-if="noticia.tpMidia == 'audio'">
                                    <audio controls="controls" poster="" width="700" height="400" allowfullscreen>
                                        <source :src="noticia.urlMidia" type="audio/mp3">
                                    </audio>
                                </template>
                                <template v-else>
                                    <VideoPlayer :options="noticia.midiaOption"></VideoPlayer>
                                </template>
                            </div>
                        </template>

                        <!--    COMPLEMENTOS    -->
                        <template v-if="user || noticia.flPublico == 'Sim' ">
                            <div class="w-100 bg-grey-1 p-4 mt-3" v-if="lstComplementos != null">
                                <div class="row mb-3" v-for="item in lstComplementos" :key="item.idNoticiaComplemento">
                                    <div class="col-12">

                                        <template v-if="item.tpComplemento == 'Video'">
                                            <button class="btn btn-blue btn-complemento reduz-texto-1" type="button" @click="showVideo(item)">
                                                <span class="reduz-texto-1"><i class="fas fa-file-video"></i> {{item.dsComplemento}}</span>
                                            </button>
                                        </template>
                                        <template v-else-if="item.tpComplemento == 'Audio'">
                                            <button class="btn btn-blue btn-complemento reduz-texto-1" type="button" @click="showAudio(item)">
                                                <span class="reduz-texto-1"><i class="fas fa-file-audio"></i> {{item.dsComplemento}}</span>
                                            </button>
                                        </template>
                                        <template v-else-if="item.tpComplemento == 'Pdf'">
                                            <a class="txt-p txt-blue-2 reduz-texto-1 c-pointer" :src="getLinkComplemento(item)" @click="geraLogComplementoItem(item.idNoticiaComplemento,getLinkComplemento(item))" target="_blank">
                                                <i class="fas fa-link"></i> {{item.dsComplemento}}
                                            </a>
                                        </template>
                                        <template v-else-if="item.tpComplemento == 'Link'">
                                            <a class="txt-p txt-blue-2 reduz-texto-1 c-pointer" :href="getLinkComplemento(item)" @click="geraLogComplementoItem(item.idNoticiaComplemento,getLinkComplemento(item))" target="_blank">
                                                <i class="fas fa-link"></i> {{item.dsComplemento}}
                                            </a>
                                        </template>

                                    </div>
                                </div>
                            </div>
                        </template>


                        <!--    AUTOR    -->
                        <div class="box-autor mt-4" v-if="noticia.autor">
                            <div class="d-flex">
                                <div class="img-autor me-5">
                                    <img class="rounded-circle" width="150" height="150" :src="noticia.autor.urlImagem" />
                                </div>
                                <div class="dados-autor d-flex flex-column">
                                    <span class="txt-h-6 txt-size-12 txt-grey-2">Escrito por</span>
                                    <p class="txt-h-3 txt-size-25 txt-blue-2 mb-2">{{noticia.autor.nmUsuario}}</p>
                                    <p class="txt-h-5 txt-size-18 txt-grey-2 txt-w-n">
                                        {{noticia.autor.dsUsuario}}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <Tags class="mt-3" :titulo="'TAGS'" :lstTags="lstTags" :link="'PesquisaNoticia'"></Tags>

                        <Comentarios class="mt-4" :id="id" :tipo="'Noticia'"></Comentarios>

                        <div class="mt-5">
                            <DivisorIcone :textSize="24" :title="'Notícias relacionadas'"></DivisorIcone>

                            <div class="row mt-3">
                                <div class="col-12 col-lg-4" v-for="item in lstNoticiasRelacionadas" :key="item.idNoticia">
                                    <router-link :to="{name:'Noticia', params:{id:item.idNoticia.toString(),n:formatLink(item.dsTitulo)}}">
                                        <img class="w-100 zoom" :src="item.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                        <p class="mb-0">
                                            <span class="txt-h-6 txt-size-12 txt-colors-1">{{item.nmSubCategoria}}</span> <span class="txt-h-6 txt-size-12 txt-grey-2 ms-2">{{formatDate(item.dtPublicacao)}}</span>
                                        </p>

                                        <p class="txt-h-4 txt-blue-2 mb-2">
                                            {{item.dsTitulo}}
                                        </p>
                                        <p class="txt-h-6 txt-grey-2 mb-0 reduz-texto-4">
                                            {{item.dsSubTitulo}}
                                        </p>
                                    </router-link>
                                </div>
                            </div>
                            <div class="mt-4 text-center">
                                <router-link :to="{name:'PesquisaNoticia'}" class="btn btn-blue px-5">
                                    MAIS NOTÍCIAS
                                </router-link>
                            </div>
                        </div>

                    </div>
                    <div class="col-12 col-md-4 mt-3">
                        <DivisorIcone :textSize="24" :title="'Mais recentes'"></DivisorIcone>

                        <div class="mais-recentes">
                            <div class="item-mais-recentes row mb-4" v-for="item in lstMaisRecentes" :key="item.idNoticia">
                                <router-link :to="{name:'Noticia', params:{id:item.idNoticia.toString(),n:formatLink(item.dsTitulo)}}" class="d-flex">
                                    <div class="col-7">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <span class="txt-h-6 txt-size-10 txt-grey-2">{{formatDate(item.dtPublicacao)}}</span>
                                            <span class="txt-h-6 txt-size-14 txt-white bg-blue-2 px-3 rounded ">{{item.nmSubCategoria}}</span>
                                        </div>
                                        <p class="txt-h-5 txt-blue-2 reduz-texto-4 mt-2">
                                            {{item.dsTitulo}}
                                        </p>
                                    </div>
                                    <div class="col-5">
                                        <img class="w-100 zoom" :src="item.urlImagemInterna" onerror="this.onerror=null; this.src='/image-not-found.jpg'" />
                                    </div>
                                </router-link>
                            </div>
                        </div>

                        <div class="banners">
                            <Banner class="mb-4"  :tipo="'Lateral'"></Banner>
                        </div>
                    </div>
                </div>
                <div class="row" style="height: 40vh;" v-else>
                    <span>Notícia não encontrada</span>
                </div>
            </div>
        </div>

        <ModalAudio :showModal="showModalAudio" :dados="audioModal"></ModalAudio>
        <ModalVideo :showModal="showModalVideo" :dados="videoModal"></ModalVideo>

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import DivisorIcone from '@/components/DivisorIcone'
    import Tags from '@/components/Tags'
    import Comentarios from '@/components/Comentarios'
    import ConteudoExclusivo from '@/components/ConteudoExclusivo'
    import AdicionarBiblioteca from '@/components/AdicionarBiblioteca'
    import ModalAudio from '@/components/ModalAudio'
    import ModalVideo from '@/components/ModalVideo'
    import Banner from '@/components/Banner'
    import VideoPlayer from '@/components/VideoPlayer'

    import { urlApi, avisoErro, _leitorPDF } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import $ from 'jquery'

    export default {
        name: 'Noticia',
        components: { Header, Footer, DivisorIcone, Tags, Comentarios, ConteudoExclusivo, AdicionarBiblioteca, ModalAudio, ModalVideo, Banner, VideoPlayer },
        props: ['id'],
        computed: {
            user() {
                return this.$store.state.user
            },
        },
        data: function () {
            return {
                title: 'Notícia',
                
                noticia: null,
                lstTags: [],
                lstNoticiasRelacionadas: [],
                lstMaisRecentes: [],
                lstComplementos: null,

                linguagem: 'pt',

                dadosExibicao: null,

                tamanhoFonte: 1,

                showModalAudio: false,
                showModalVideo: false,
                showModalConteudoExclusivo: false,
                hideModalConteudoExclusivo: false,

                audioModal: null,
                videoModal: null,

                idLogNoticiaComplemento: 0,
                qtdCaracteresCopia: 700,
                // ---------- //

                metaTags: {
                    title: "Sollicita",
                    meta: [
                        { itemprop: 'name', content: '' },
                        { itemprop: 'description', content: '' },
                        { itemprop: 'image', content: '' },

                        { name: 'twitter:card', content: 'summary' },
                        { name: 'twitter:site', content: '' },
                        { name: 'twitter:title', content: '' },
                        { name: 'twitter:description', content: '' },
                        { name: 'twitter:creator', content: '' },
                        { name: 'twitter:image', content: '' },

                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:title', content: '' },
                        { property: 'og:url', content: '' },
                        { property: 'og:image', content: '' },
                        { property: 'og:image:secure_url', content: '' },
                        { property: 'og:image:type', content: 'image/png' },
                        { property: 'og:description', content: '' },
                        { property: 'og:site_name', content: 'Sollicita' },
                        { property: 'og:image:width', content: '300' },
                        { property: 'og:image:height', content: '200' },
                        { property: 'fb:admins', content: 'sollicita' },
                        { property: 'og:type', content: 'website' },

                        { name: 'application-name', content: 'Sollicita' },
                        { name: 'theme-color', content: '#2d5289' },
                        { name: 'msapplication-TileColor', content: '#2d5289' },
                        { name: 'msapplication-TileImage', content: '' },                       
                    ]
                },
            }
        },
        metaInfo() {
            return this.metaTags
        },
        methods: {
            load() {
                this.carregaNoticia();
                this.carregaNoticiasRelacionadas();
                this.carregaMaisRecentes();
            },

            carregaNoticia() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get/${$this.id}`)
                    .then(res => {
                        if (res.data.success) {
                            var noticia = res.data.data;
                            noticia.urlImagem = $this.getUrlS3(noticia.urlImagem);
                            noticia.urlImagemInterna = $this.getUrlS3(noticia.urlImagemInterna);
                            if (noticia.urlMidia != null && noticia.urlMidia != "") {
                                noticia.tpMidia = noticia.urlMidia.toUpperCase().includes(".AAC") || noticia.urlMidia.toUpperCase().includes(".OGG") || noticia.urlMidia.toUpperCase().includes(".WMA") || noticia.urlMidia.toUpperCase().includes(".MP3") ? "audio" : "video";
                                noticia.urlMidia = $this.getUrlS3(noticia.urlMidia);
                                noticia.midiaOption = {
                                    autoplay: false,
                                    controls: true,
                                    sources: [
                                        {
                                            src: noticia.urlMidia,
                                            type: "video/mp4"
                                        }
                                    ]
                                };
                            }
                            

                            $this.noticia = noticia;
                            // SET TITLE PARA ARTIGO
                            if ($this.noticia.nmSubCategoria == "Artigo") {
                                $this.title = "Artigo";
                            }
                            $this.setMetaTags();

                            $this.$nextTick(function () {
                                // DOM updated
                                $this.formataNoticia();
                                // AJUSTE TECNICO PARA IMAGENS ANTIGAS COM URL EXPIRADA
                                $('img[data-url]').each(function () {
                                    $(this).addClass('img-fluid');
                                    $(this).attr('src', '/File/getFile?url=/NP/SollicitaAdmin/' + $(this).data('url'));
                                });
                                $('.conteudo-noticia img').each(function () {
                                    if ($(this).attr('src').indexOf('./../File/getFile?url=') != -1) {
                                        var n_url = $(this).attr('src').replace('./../File/getFile?url=', '');
                                        $(this).attr('src', urlApi + '/Utilidade/GetUrlS3?url=' + n_url);
                                    }
                                    
                                });

                            });

                            $this.dadosExibicao = {
                                dsTitulo: $this.noticia.dsTitulo,
                                dsSubTitulo: $this.noticia.dsSubTitulo,
                                htmNoticia: $this.noticia.htmNoticia,
                            };
                            
                            $this.montaTags($this.noticia.dsTags);

                            if ($this.user || $this.noticia.flPublico == 'Sim') {
                                $this.carregaComplementos($this.noticia.idNoticia);
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar a notícia");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a notícia");
                        $this.noticiaDestaque = null;
                    });
            },

            setMetaTags() {
                var $this = this;
                var imgDefault = window.location.origin + '114px_rounded.png';
                $this.metaTags = {
                    title: ($this.noticia.dsTitulo + " | Sollicita" ? $this.noticia.dsTitulo : "Sollicita"),
                    meta: [
                        { itemprop: 'name', content: ($this.noticia.dsTitulo + " | Sollicita" ? $this.noticia.dsTitulo: "Sollicita" ) },
                        { itemprop: 'description', content: ($this.noticia.dsSubTitulo ? $this.noticia.dsSubTitulo : "O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública." ) },
                        { itemprop: 'image', content: imgDefault },

                        { name: 'twitter:card', content: 'summary' },
                        { name: 'twitter:site', content: '@gruponp' },
                        { name: 'twitter:title', content: ($this.noticia.dsTitulo + " | Sollicita" ? $this.noticia.dsTitulo : "Sollicita") },
                        { name: 'twitter:description', content: ($this.noticia.dsSubTitulo ? $this.noticia.dsSubTitulo : "O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.") },
                        { name: 'twitter:creator', content: '@gruponp' },
                        { name: 'twitter:image', content: ($this.noticia.urlImagemInterna ? $this.noticia.urlImagemInterna : imgDefault) },

                        { property: 'og:locale', content: 'pt_BR' },
                        { property: 'og:title', content: ($this.noticia.dsTitulo + " | Sollicita" ? $this.noticia.dsTitulo : "Sollicita") },
                        { property: 'og:url', content: window.location.href },
                        { property: 'og:image', content: ($this.noticia.urlImagemInterna ? $this.noticia.urlImagemInterna : imgDefault) },
                        { property: 'og:image:secure_url', content: ($this.noticia.urlImagemInterna ? $this.noticia.urlImagemInterna : imgDefault) },
                        { property: 'og:image:type', content: 'image/png' },
                        { property: 'og:description', content: ($this.noticia.dsSubTitulo ? $this.noticia.dsSubTitulo : "O Sollicita é a plataforma mais completa para você que atua com Licitações e Contratos Administrativos para a Administração Pública.") },
                        { property: 'og:site_name', content: 'Sollicita' },
                        { property: 'og:image:width', content: '300' },
                        { property: 'og:image:height', content: '200' },
                        { property: 'fb:admins', content: 'sollicita' },
                        { property: 'og:type', content: 'website' },

                        { name: 'application-name', content: 'Sollicita' },
                        { name: 'theme-color', content: '#2d5289' },
                        { name: 'msapplication-TileColor', content: '#2d5289' },
                        { name: 'msapplication-TileImage', content: ($this.noticia.urlImagemInterna ? $this.noticia.urlImagemInterna : imgDefault) },
                    ]
                };
            },

            formataNoticia() {
                $('.conteudo-noticia').find('*').each(function () {
                    var thats = this;
                    $.each(this.style, function (i, v) {
                        if ($.inArray(v, ['background', 'background-color', 'font-family', 'font-size', 'line-height', 'letter-spacing', 'word-spacing']) > - 1) {
                            //console.log($(thats).css('background-color'));
                            if ($(thats).css('background-color') == 'rgb(255, 255, 255)') {
                                $(thats).css('background-color', 'initial');
                            }

                            $(thats).css('font-family', 'Roboto');
                            $(thats).css('line-height', '2rem');
                            $(thats).css('letter-spacing', '.05rem');
                            $(thats).css('word-spacing', '');
                        }
                    });
                });
                $('.conteudo-noticia').css('visibility', 'visible');
            },

            carregaNoticiasRelacionadas() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/NoticiasRelacionadas`, { params: { idNoticia: $this.id, take: 3, index: 0} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstNoticiasRelacionadas = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let noticia = res.data.data.rows[i];
                                    noticia.urlImagem = $this.getUrlS3(noticia.urlImagem);
                                    noticia.urlImagemInterna = $this.getUrlS3(noticia.urlImagemInterna);

                                    $this.lstNoticiasRelacionadas.push(noticia);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar as notícias");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar as notícias");
                        $this.noticiaDestaque = null;
                    });
            },

            carregaMaisRecentes() {
                let $this = this;
                axios.get(`${urlApi}/Noticia/Get`, { params: { take: 5, index: 0, isNoticiaPrincipal: false } })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstMaisRecentes = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let noticia = res.data.data.rows[i];
                                    noticia.urlImagem = $this.getUrlS3(noticia.urlImagem);
                                    noticia.urlImagemInterna = $this.getUrlS3(noticia.urlImagemInterna);

                                    $this.lstMaisRecentes.push(noticia);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar \"mais recentes\"");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar \"mais recentes\"");
                        $this.noticiaDestaque = null;
                    });
            },

            carregaComplementos(idNoticia) {
                let $this = this;
                $this.geraLogComplemento();
                axios.get(`${urlApi}/Noticia/ComplementosNoticia/${idNoticia}`)
                    .then(res => {
                        if (res.data.success) {
                            $this.lstComplementos = [];
                            if (res.data.data.rows != null) {
                                for (let i = 0; i < res.data.data.rows.length; i++) {
                                    let item = res.data.data.rows[i];

                                    $this.lstComplementos.push(item);
                                }
                            }
                        } else {
                            avisoErro("Não foi possível carregar os complementos");
                            $this.lstComplementos = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os complementos");
                        $this.lstComplementos = null;
                    });
            },

            //  AÇÕES COMPLEMENTOS
            showVideo(complemento) {
                this.geraLogComplementoItem(complemento.idNoticiaComplemento);
                complemento.p_idVideo = complemento.idNoticiaComplemento;
                complemento.p_tipo = "ComplementoNoticia";
                complemento.p_tpExibicao = "Local";
                this.videoModal = complemento;
                this.showModalVideo = !this.showModalVideo;
            },

            showAudio(complemento) {
                this.geraLogComplementoItem(complemento.idNoticiaComplemento);
                complemento.p_idAudio = complemento.idNoticiaComplemento;
                complemento.p_tipo = "ComplementoNoticia";
                complemento.p_tpExibicao = "Local";
                this.audioModal = complemento;
                this.showModalAudio = !this.showModalAudio;
            },

            getLinkComplemento(complemento) {
                if (complemento.tpComplemento == 'Pdf') {
                    if (complemento.urlArquivo.substr(0, 1) != '/') {
                        complemento.urlArquivo = '/' + complemento.urlArquivo
                    }
                    return _leitorPDF + complemento.urlArquivo;
                } else {
                    return complemento.urlArquivo
                }
            },

            geraLogComplemento() {
                let $this = this;
                axios.post(`${urlApi}/Log/LogNoticiaComplemento`, { p_idLogNoticiaComplemento: 0, p_idNoticia: $this.noticia.idNoticia })
                    .then(res => {
                        if (res.data.success) {
                            $this.idLogNoticiaComplemento = res.data.msg;
                        }else {
                            console.log("Erro Log");
                        }
                    })
                    .catch(function () {
                        console.log("Erro Log");
                    });
            },

            geraLogComplementoItem(idNoticiaComplemento, url){
                let $this = this;
                axios.post(`${urlApi}/Log/LogNoticiaComplementoItem`, { p_idLogNoticiaComplemento: parseInt($this.idLogNoticiaComplemento), p_idNoticiaComplemento: idNoticiaComplemento })
                    .then(res => {
                        if (res.data.success) {
                            if (url) {
                                window.open(url, '_blank').focus();
                            }
                        } else {
                            console.log("Erro Log");
                        }
                    })
                    .catch(function () {
                        console.log("Erro Log");
                    });
            },

            montaTags(tags) {
                let $this = this;
                if (tags != null && tags != undefined) {
                    tags = tags.split(';');
                    if (tags != undefined && tags != null && tags != '') {
                        for (let i = 0; i < tags.length; i++) {
                            let tag = tags[i].trim();
                            $this.lstTags.push(tag);
                        }
                    }
                }
            },

            formatDate(date) {
                return moment(date).format('DD/MM/YYYY [às] HH:mm');
            },

            formatLink(titulo) {
                if (titulo) {
                    return titulo.toLowerCase().replace(/\s/g, '-');
                } else {
                    return "";
                }

            },

            trocaLinguagem() {
                let $this = this;
                if ($this.linguagem == 'pt') {
                    $this.linguagem = 'en';
                    $this.dadosExibicao = {
                        dsTitulo: $this.noticia.noticiaIngles.dsTitulo,
                        dsSubTitulo: $this.noticia.noticiaIngles.dsSubTitulo,
                        htmNoticia: $this.noticia.noticiaIngles.htmNoticia,
                    };
                } else {
                    $this.linguagem = 'pt';
                    $this.dadosExibicao = {
                        dsTitulo: $this.noticia.dsTitulo,
                        dsSubTitulo: $this.noticia.dsSubTitulo,
                        htmNoticia: $this.noticia.htmNoticia,
                    };
                }
            },

            trocaFonte(tipo) {
                let $this = this;
                if (tipo == 2) {
                    $this.tamanhoFonte = parseFloat($this.tamanhoFonte) + parseFloat(0.1);
                } else {
                    $this.tamanhoFonte = parseFloat($this.tamanhoFonte) - parseFloat(0.1);
                }
            },

            getLinkShare(tipo) {
                var url = window.location.href;
                var uri = '';
                switch (tipo) {
                    case 1:
                        // facebook
                        return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURI( url);
                    case 2:
                        // twitter
                        uri = encodeURI(this.noticia.dsTitulo + ' ' + url)
                        return 'https://twitter.com/intent/tweet?text=' + uri
                    case 3:
                        // linkedin
                        return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURI(url);
                    case 4:
                        var conteudo = encodeURIComponent(document.title + " " + window.location.href);
                        return "https://api.whatsapp.com/send?text=" + conteudo;
                       
                }
            },

            share() {
                navigator.share({
                    title: document.title,
                    url: window.location.href
                })
                return false;
            },

            liberaConteudo() {
                this.load();
            },

            getUrlS3(url) {
                return `${urlApi}/Utilidade/GetUrlS3?url=${url}`;
            },

        },
        created: function () {
            let $this = this;
            $this.load();
            document.addEventListener("copy", function (evt) {
                let selection = document.getSelection().toString();

                // Change the copied text if you want
                if (selection.length > $this.qtdCaracteresCopia) {
                    selection = selection.slice(0, $this.qtdCaracteresCopia) + "... Veja mais em " + window.location.href;
                } else {
                    selection = selection.slice(0, $this.qtdCaracteresCopia) + " Veja mais em " + window.location.href;
                }
                var data = new Date(); 
                evt.clipboardData.setData("text/plain", selection + " - Copyright © " + data.getFullYear() +", Sollicita. Todos os direitos reservados.");

                // Prevent the default copy action
                evt.preventDefault();
            }, false);
        },
        watch: {
            id() {
                this.load();
            }
        }
    };
</script>

<style lang="scss">
    .conteudo-noticia blockquote {
        padding: 2px 8px 2px 20px;
        border-left-width: 5px;
        font-style: italic;
        font-family: Georgia, Times, "Times New Roman", serif;
        border-left: 5px solid #ccc;
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 40px;
        margin-inline-end: 40px;
    }
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    

    .conteudo-noticia {
        word-break: break-word;
        text-align: start;
        img {
            max-width: 100%;
            height: auto !important;
        }
    }

    

    .imagem-noticia {
        width: 100%;
        height: auto;
        max-height: 560px;
    }
        
    .divisor-rigth{
        border-right: 1px solid color('grey','7');
    }

</style>

